import { createSlice } from "@reduxjs/toolkit";

// ----------------------------------------------------------------------

const slice = createSlice({
  name: "divisions",

  initialState: {
    isLoadingDivisionsForSchool: false,
  },

  reducers: {},

  extraReducers: {},
});

// Reducer
export default slice.reducer;

// Actions
// export const {  } = slice.actions;
